// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__dgfZX","show":"styles_show__5yzNU","hideScrollbar":"styles_hideScrollbar__gQrxs","container":"styles_container__DALyh"};